import { render, staticRenderFns } from "./UsersEdit.vue?vue&type=template&id=66dd32e9&"
import script from "./UsersEdit.vue?vue&type=script&lang=ts&"
export * from "./UsersEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports